export type QueryOptions<TData = unknown> = {
    enabled?: boolean
    refetchInterval?: number | false | ((data: TData | undefined) => number | false)
}

export const defaultOptions: QueryOptions = {
    enabled: true,
}
